export default __webpack_public_path__ + "static/media/preview-open.1ddbf279.svg";